export default __webpack_public_path__ + "static/media/1.9cf59ca1.jpeg";